import React from 'react';
import { withStyles } from '@material-ui/styles';
import logo from '../system/images/logo.svg';

// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

const styles = theme => ({});

const Logo = props => {
    // const classes = _get(props, 'classes');

    return (
        <img
            src={logo}
            // src="https://firebasestorage.googleapis.com/v0/b/afitd-assets.appspot.com/o/images%2Flogo%2Fafitd_logo_562.webp?alt=media&token=4b58010b-fe7b-4619-8e35-b94192f9c41f"
            alt="A Foot in the Door Logo"
            {...props}
        />
    );
};

export default withStyles(styles)(Logo);
